import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HomeleiteTenant } from './tenant';
import { ReadonlyRepositoryImpl } from 'libs/arch/src/lib/repositories';
import { ApiService } from 'libs/arch/src/lib/api';

@Injectable({ providedIn: 'root' })
export class TenantsRepository extends ReadonlyRepositoryImpl<
  HomeleiteTenant,
  HomeleiteTenant
> {
  constructor(api: ApiService) {
    super(api.root.path('/public/tenants'), HomeleiteTenant, HomeleiteTenant);
  }

  fetchDefault(): Observable<HomeleiteTenant> {
    return this.api
      .path('/default')
      .getJson()
      .pipe(map((v) => HomeleiteTenant.fromJson(v)));
  }
}
